export enum OTP_DIALOG_TYPES {
  SOMETHING_WENT_WRONG = "SOMETHING_WENT_WRONG",
  OTP_VERIFY_REQUEST_IS_FAILED = "OTP_VERIFY_REQUEST_IS_FAILED",
  PROVIDE_OFFER_ERROR = "PROVIDE_OFFER_ERROR",
  SOMETHING_WRONG_WITH_USER_DATA = "SOMETHING_WRONG_WITH_USER_DATA",
  UNDER_DELETION = "UNDER_DELETION",
}
